import {
  TextField,
  Box,
  Typography,
  Stack,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Tooltip,
  IconButton,
  Paper,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { axiosGetCall, axiosPostCall, axiosPatchCall } from 'src/services/apisCall';

import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import Logger from '../../../lib/Logger';
import Iconify from '../../../components/iconify';

const logger = new Logger('asetting');

const PermissionCardAnnUrlToTrans = ({
  label,
  typeKey,
  checked,
  onChange,
  userType,
  requestFor,
  setRequestFor,
  // onReset,
  onSubmit,
  loading,
}) => {
  return (
    <Box
      variant="outlined"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        p: 2,
        borderRadius: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2} flex={1}>
        <Checkbox checked={checked} onChange={onChange} />
        <Typography variant="body1">{label}</Typography>
      </Stack>

      <Stack direction="row" spacing={1}>
        {userType === 'reseller' && (
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel id={`${typeKey}-select`}>Request For</InputLabel>
            <Select
              labelId={`${typeKey}-select`}
              value={requestFor || ''}
              onChange={(e) => setRequestFor(e.target.value)}
            >
              {requestList.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <LoadingButton loading={loading} variant="contained" onClick={onSubmit}>
          Submit
        </LoadingButton>
      </Stack>
    </Box>
  );
};

const PermissionCard = ({
  label,
  typeKey,
  checked,
  onChange,
  userType,
  requestFor,
  setRequestFor,
  // onReset,
  onSubmit,
  loading,
}) => {
  return (
    <Box
      variant="outlined"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        p: 2,
        borderRadius: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2} flex={1}>
        <Checkbox checked={checked} onChange={onChange} />
        <Typography variant="body1">{label}</Typography>
      </Stack>

      <Stack direction="row" spacing={1}>
        {userType === 'reseller' && (
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel id={`${typeKey}-select`}>Request For</InputLabel>
            <Select
              labelId={`${typeKey}-select`}
              value={requestFor || ''}
              onChange={(e) => setRequestFor(e.target.value)}
            >
              {requestList.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <LoadingButton loading={loading} variant="contained" onClick={onSubmit}>
          Submit
        </LoadingButton>
      </Stack>
    </Box>
  );
};

const BasicDatePicker = ({ value, onChange, dateError, resetError, label }) => {
  const [, setOpen] = useState(false);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        views={['hours']}
        label={label}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slotProps={{
          textField: {
            size: 'small',
            error: Boolean(dateError),
            helperText: Boolean(dateError) && dateError,
            onClick: () => resetError(),
          },
          actionBar: {
            actions: ['today', 'clear'],
          },
        }}
        ampm={true}
        value={value}
        onChange={(newValue) => onChange(newValue)}
      />
    </LocalizationProvider>
  );
};

const requestList = [
  { label: 'Self', value: 'U' },
  { label: 'Downline', value: 'D' },
  { label: 'Hierarchy', value: 'H' },
];

const dndStatusList = [
  { label: 'On', value: '1' },
  { label: 'Off', value: '0' },
];

const BroadcastPermissions = ({ user }) => {
  const inputSx = {
    color: 'grey.900',
    borderColor: 'grey.700',
    borderRadius: '6px',
  };

  const [anouncementUploadLimit, setAnouncementUploadLimit] = useState(0);
  const [announcementAproveAll, setAnnouncementApproveAll] = useState(false);
  const [templateApprove, setTemplateApprove] = useState(false);
  const [type, setType] = useState([]);
  const [requestForAnn, setRequestForANN] = useState('U');
  const [requestForIVR, setRequestForIVR] = useState('U');
  const [requestForTTS, setRequestForTTS] = useState('U');
  const [requestForAnnUrltoTrans, setRequestForAnnUrltoTrans] = useState('U');
  const [resetRequestFor, setResetRequestFor] = useState('U');
  const [approveIVR, setApproveIVR] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [announcementUrltoTrans, setAnnouncementUrltoTrans] = useState(false);
  const [numberMasking, setNumberMasking] = useState(false);
  const [requestForNumberMasking, setRequestForNumberMasking] = useState('U');
  const [viewOldData, setViewOldData] = useState(false);
  const [requestForViewOldData, setRequestForViewOldData] = useState('U');
  const [pttsCharLimit, setPttsCharLimit] = useState(0);
  const [pttsCharLimitRequestFor, setPttsCharLimitRequestFor] = useState('U');

  const [callWindowloader, setCallWindowLoader] = useState(false);
  const [load, setLoad] = useState(false);

  const handleReset = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: 'autoApproval',
      requestFor: 'U',
    };
    if (user?.voiceInfo?.userType === 'reseller') {
      payload.requestFor = resetRequestFor;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      fetchSettingDetails();
      renderSuccessMessage('Settings reset successfully');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };
  const handleResetAnnUrltoTrans = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: 'annURLToTrans',
      requestFor: 'U',
    };
    if (user?.voiceInfo?.userType === 'reseller') {
      payload.requestFor = requestForAnnUrltoTrans;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      fetchSettingAnnouncementDetails();
      renderSuccessMessage('Settings reset successfully');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };
  const handleAutoApproveAll = async (e) => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'autoApproval',
        type: e,
        requestFor: 'U',
      };
      if (type === 'announcement') {
        if (user?.voiceInfo?.userType === 'reseller') {
          payload.requestFor = requestForAnn;
        }
      } else if (type === 'ivr') {
        if (user?.voiceInfo?.userType === 'reseller') {
          payload.requestFor = requestForIVR;
        }
      } else if (type === 'ttsTemplate') {
        if (user?.voiceInfo?.userType === 'reseller') {
          payload.requestFor = requestForTTS;
        }
      }
      setCallWindowLoader(true);
      await axiosPatchCall('updateProfileSetting', payload);
      setCallWindowLoader(false);
      renderSuccessMessage(`Success ${e} auto approve setting updated`);
    } catch (error) {
      logger.error(error);
      setCallWindowLoader(false);
      renderErrorMessage(error.message);
    }
  };

  const handelannurltoTrans = async (type) => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'annURLToTrans',
        annURLToTrans: announcementUrltoTrans,
        requestFor: 'U',
      };
      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = requestForAnnUrltoTrans;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      renderSuccessMessage(`Success Announcement URL to Transcript setting updated`);
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };

  const handleNumberMasking = async (type) => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'numberMasking',
        status: numberMasking,
        requestFor: 'U',
      };
      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = requestForNumberMasking;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      renderSuccessMessage(`Success Number Masking setting updated`);
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  }

  const handleResetNumberMasking = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: 'numberMasking',
      requestFor: 'U',
    };
    if (user?.voiceInfo?.userType === 'reseller') {
      payload.requestFor = requestForNumberMasking;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      fetchSettingNumberMasking();
      renderSuccessMessage('Settings reset successfully');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };

  const handleResetPttsCharLimit = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: 'pttsCharLimit',
      requestFor: 'U',
    };
    if (user?.voiceInfo?.userType === 'reseller') {
      payload.requestFor = pttsCharLimitRequestFor;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      fetchSettingPttsCharsLimit();
      renderSuccessMessage('Settings reset successfully');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };

  const handleViewOldData = async (type) => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'viewOldData',
        status: viewOldData,
        requestFor: 'U',
      };
      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = requestForViewOldData;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      renderSuccessMessage(`Success View Old Data setting updated`);
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  }

  const handlePttsCharLimit = async (type) => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'pttsCharLimit',
        allowNoOfChars: pttsCharLimit,
        requestFor: 'U',
      };
      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = requestForViewOldData;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      renderSuccessMessage(`Success View Old Data setting updated`);
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  }

  const handleResetViewOldData = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: 'viewOldData',
      requestFor: 'U',
    };
    if (user?.voiceInfo?.userType === 'reseller') {
      payload.requestFor = requestForViewOldData;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      fetchSettingViewOldData();
      renderSuccessMessage('Settings reset successfully');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };

  const handleSubmit = async (type) => {
    if (type === 'announcement') {
      if (announcementAproveAll === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handleAutoApproveAll(type);
    }

    if (type === 'ivr') {
      if (approveIVR === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handleAutoApproveAll(type);
    }

    if (type === 'ttsTemplate') {
      if (templateApprove === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handleAutoApproveAll(type);
    }
    if (type === 'annURL') {
      if (announcementUrltoTrans === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handelannurltoTrans(type);
    }
    if (type === 'numberMasking') {
      if (numberMasking === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handleNumberMasking(type);
    }
    if (type === 'viewOldData') {
      if (viewOldData === false) {
        renderErrorMessage('Please check the checkbox to proceed');
        return;
      }
      await handleViewOldData(type);
    }
    if (type === 'pttsCharLimit') {
      if (pttsCharLimit === 0 && pttsCharLimit !== '' && pttsCharLimit !== null) {
        renderErrorMessage('Please enter valid character limit');
        return;
      }
      await handlePttsCharLimit(type);
    }
  };

  const fetchSettingDetails = async () => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'getAutoApproval' };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      const { announcement_auto_approved, ivr_auto_approved, tts_auto_approved } = data?.auto_approved || {};
      setAnnouncementApproveAll(announcement_auto_approved == 1 ? true : false);
      setTemplateApprove(tts_auto_approved == 1 ? true : false);
      setApproveIVR(ivr_auto_approved == 1 ? true : false);
      setStartTime(startTime);
      setEndTime(endTime);
    } catch (error) {
      logger.error(error);
    }
  };

    const fetchSettingNumberMasking = async () => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'getNumberMasking' };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      setNumberMasking(data?.numberMasking == false ? false : true);
    } catch (error) {
      logger.error(error);
    }
  };

  const fetchSettingViewOldData = async () => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'getViewOldData' };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      setViewOldData(data?.viewOldData == false ? false : true);
    } catch (error) {
      logger.error(error);
    }
  };


  const fetchSettingAnnouncementDetails = async () => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'getAnnURLToTrans' };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      setAnnouncementUrltoTrans(data?.ann_url_to_trans == false ? false : true);
    } catch (error) {
      logger.error(error);
    }
  };

  const fetchSettingPttsCharsLimit = async () => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'pttsCharsLimit' };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      setPttsCharLimit(data?.pttsCharsLimit === false ? '--' : data?.pttsCharsLimit);
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    fetchSettingDetails();
    fetchSettingAnnouncementDetails();
    fetchSettingNumberMasking();
    fetchSettingViewOldData();
    fetchSettingPttsCharsLimit();
  }, [load]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          mt: '10px',
          maxHeight: '30rem',
          overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
          }}
        >
          <Typography>Auto Approve Permission</Typography>
          <Box
            sx={{
              border: '0.5px dashed',
              borderColor: 'gray.400',
              borderRadius: '7px',
              padding: '12px',
              paddingTop: '14px',
              position: 'relative',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'flex-end', mb: 2 }}>
              {user?.voiceInfo?.userType == 'reseller' && (
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel id={`select`}>Request For</InputLabel>
                  <Select
                    labelId={`select`}
                    value={resetRequestFor || ''}
                    onChange={(e) => setResetRequestFor(e.target.value)}
                  >
                    {requestList.map(({ label, value }) => (
                      <MenuItem key={value} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <LoadingButton variant="contained" onClick={handleReset}>
                <Iconify icon="ix:reset" />
                Reset All
              </LoadingButton>
            </Box>

            <PermissionCard
              label="Announcement Auto Approve"
              typeKey="announcement"
              checked={announcementAproveAll}
              onChange={(e) => setAnnouncementApproveAll(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForAnn}
              setRequestFor={setRequestForANN}
              onSubmit={() => handleSubmit('announcement')}
              // loading={loader}
            />

            <PermissionCard
              label="IVR Auto Approve"
              typeKey="ivr"
              checked={approveIVR}
              onChange={(e) => setApproveIVR(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForIVR}
              setRequestFor={setRequestForIVR}
              onSubmit={() => handleSubmit('ivr')}
              // loading={loader}
            />

            <PermissionCard
              label="Template Auto Approve"
              typeKey="tts"
              checked={templateApprove}
              onChange={(e) => setTemplateApprove(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForTTS}
              setRequestFor={setRequestForTTS}
              onSubmit={() => handleSubmit('ttsTemplate')}
              // loading={loader}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
          }}
        >
          <Box
            sx={{
              border: '0.5px dashed',
              borderColor: 'gray.400',
              borderRadius: '7px',
              padding: '12px',
              paddingTop: '14px',
              position: 'relative',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
              <LoadingButton variant="contained" onClick={handleResetAnnUrltoTrans}>
                <Iconify icon="ix:reset" />
                Reset All
              </LoadingButton>
            </Box>
            <PermissionCardAnnUrlToTrans
              label="Announcement URL to Trans"
              typeKey="annURLToTrans"
              checked={announcementUrltoTrans}
              onChange={(e) => setAnnouncementUrltoTrans(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForAnnUrltoTrans}
              setRequestFor={setRequestForAnnUrltoTrans}
              onSubmit={() => handleSubmit('annURL')}
              // loading={loader}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
          }}
        >
          <Box
            sx={{
              border: '0.5px dashed',
              borderColor: 'gray.400',
              borderRadius: '7px',
              padding: '12px',
              paddingTop: '14px',
              position: 'relative',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="body1">
                <span style={{ color: 'red' }}> Example Number :- </span>
                <span>
                  {numberMasking ? "*********999" : "919999999999"}
                </span>
              </Typography>
              <LoadingButton variant="contained" onClick={handleResetNumberMasking}>
                <Iconify icon="ix:reset" />
                Reset All
              </LoadingButton>
             
            </Box>
            <PermissionCard
              label="Number masking"
              typeKey="numberMasking"
              checked={numberMasking}
              onChange={(e) => setNumberMasking(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForNumberMasking}
              setRequestFor={setRequestForNumberMasking}
              onSubmit={() => handleSubmit('numberMasking')}
              // loading={loader}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
          }}
        >
          <Box
            sx={{
              border: '0.5px dashed',
              borderColor: 'gray.400',
              borderRadius: '7px',
              padding: '12px',
              paddingTop: '14px',
              position: 'relative',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="body1">
                View Data from 6 to 9 Months
              </Typography>
              <LoadingButton variant="contained" onClick={handleResetViewOldData}>
                <Iconify icon="ix:reset" />
                Reset All
              </LoadingButton>
             
            </Box>
            <PermissionCard
              label="View Old Data"
              typeKey="viewOldData"
              checked={viewOldData}
              onChange={(e) => setViewOldData(e.target.checked)}
              userType={user?.voiceInfo?.userType}
              requestFor={requestForViewOldData}
              setRequestFor={setRequestForViewOldData}
              onSubmit={() => handleSubmit('viewOldData')}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
          }}
        >
          <Box
            sx={{
              border: '0.5px dashed',
              borderColor: 'gray.400',
              borderRadius: '7px',
              padding: '12px',
              paddingTop: '14px',
              position: 'relative',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="body1">
                PTTS character limit applies only to the TTS and Bulk TTS APIs.
              </Typography>
              <LoadingButton variant="contained" onClick={handleResetPttsCharLimit}>
                <Iconify icon="ix:reset" />
                Reset All
              </LoadingButton>

            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="PTTS Char Limit"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={pttsCharLimit}
                onChange={(e) => setPttsCharLimit(e.target.value)}
                size="small"
              />
              {user?.voiceInfo?.userType === "reseller" && (
                <Stack
                  gap={2}
                  direction={"row"}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="request-select">Request For</InputLabel>
                    <Select
                      labelId="request-select"
                      id="request-select"
                      value={pttsCharLimitRequestFor || ""}
                      onChange={(e) => setPttsCharLimitRequestFor(e?.target?.value)}
                      label="Request For"
                      size="small"
                      displayEmpty
                    >
                      {requestList.map(({ label, value }) => (
                        <MenuItem key={label} value={value}>
                          {label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Stack direction={"row"} gap={1}>
                  {/* <IconButton onClick={() => handleReset("pttsCharLimit")}>
                                    <Iconify icon="ix:reset" />
                                </IconButton> */}
                  <LoadingButton
                    variant="contained"
                    sx={{ width: "100px" }}
                    onClick={() => handleSubmit("pttsCharLimit")}
                  >
                    Submit
                  </LoadingButton>
                </Stack>
              </Box>
            </Box>
          </Box>

        </Box>
      </Box>
    </>
  );
};

export default BroadcastPermissions;
